import { v4 } from 'uuid';
import Style from '@/components/four-step-component/style';
import BlockStyle from '@/components/four-step-component/four-step-block/style';
import { child } from '@splidejs/splide/src/js/utils';
import { FontStyle } from '@/components/style';

export default class FourStepComponent extends HTMLElement {
  constructor() {
    super();
    this.uuid = v4();
    this.phoneSizeThreshold = 1000;
    this.imageContainerId = `${this.constructor.name}_${this.uuid}_image`;
    this.isSmall = false;
    this.currentImage = 'test';
    this.currentTitle = 'ffff';
    this.currentDescription = 'hhhh';
    this.currentEyebrow = '22222';
    this.currenButtonIndex = 0;
    this.currentCtaStyle = 'cta-1';

    this.attachShadow({ mode: 'open' });

    this.render();

    const object = this;
    this.resizeObserver = new ResizeObserver((entries) => {
      object.isSmall = window.innerWidth < object.phoneSizeThreshold;

      object.render();
      object.connectButtonEvents();
    });
  }

  render() {
    const blockInside = this.querySelectorAll('four-step-block');
    const buttonTitles = [];
    blockInside.forEach((element) => {
      const buttonTitle = element.getAttribute('buttonTitle');
      buttonTitles.push(buttonTitle.toUpperCase());
    });

    const buttons = buttonTitles.map((item, index) => {
      return `
      <div class="four-step-item-button-container">
        <button
            class="four-step-button body-font-1"
            ${!this.isSmall && `style="width: 72px; height: 72px"`}
            id="${this.imageContainerId}-button-${index}"
            >
            0${index + 1}
        </button>
        <div class="body-font-2">
            ${item}
        </div>
      </div>
      `;
    });

    if (this.isSmall) {
      this.shadowRoot.innerHTML = `
            ${FontStyle}
            ${Style({ isMobile: this.isSmall })}
            <div style="width: 100px" class="four-step-child-content-container">
                <slot>
                </slot>
            </div>
            <div style="background-color: ${
              this.backgroundColor
            }; width: 100%; height: 40px"></div>
            <div
                style="
                    background-color: ${this.backgroundColor};
                    border-radius: 0 0 10px 10px;
                    "
                class="four-step-button-container">
                ${buttons.join('')}
            </div>
        `;
    } else {
      this.shadowRoot.innerHTML = `
      ${FontStyle}
      ${Style({ isMobile: this.isSmall })}
      ${BlockStyle}
      <style>
      </style>
      <slot style="display: none"></slot>
      <div class="four-step-desktop-container">
        <div class="image four-step-desktop-image-container"></div>
        <div
            style="background-color: ${this.backgroundColor};"
            class="four-step-desktop-text-container">
            <div class="eyebrow body-font-4">${this.currentEyebrow}</div>
            <div class="title title-font-5">${this.currentTitle}</div>
            <div class="description body-font-1">${
              this.currentDescription
            }</div>
            <a class="${this.currentCtaStyle} cta" href="${this.currentLink}">
                 learn
                <span class="dash"></span>
                more
            </a>
            <div style="margin-top: auto" class="four-step-button-container">
                ${buttons.join('')}
            </div>
        </div>
      </div>

    `;
    }

    //this.shadowRoot.style.backgroundColor = this.backgroundColor;
  }

  connectedCallback() {
    this.resizeObserver.observe(this);

    this.connectButtonEvents();
  }

  connectButtonEvents() {
    this.buttons = this.shadowRoot.querySelectorAll('.four-step-button');

    const slot = this.shadowRoot.querySelector('slot');
    const assignedNodes = slot.assignedNodes();

    this.blockElements = assignedNodes.filter(
      (node) => node.nodeType === Node.ELEMENT_NODE
    );

    if (!this.isSmall) {
      this.blockObjects = this.blockElements.map((node) => ({
        eyebrow: node.getAttribute('eyebrow'),
        title: node.getAttribute('title'),
        description: node.getAttribute('description'),
        link: node.getAttribute('link'),
        linkText: node.getAttribute('linkText'),
        image: node.getAttribute('imgSrc'),
        ctaStyle: node.getAttribute('ctaStyle')
      }));
    }

    this.showDesiredChildByIndex(this.currenButtonIndex);

    const self = this;

    self.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        self.showDesiredChildByIndex(index);
      });
    });
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  showDesiredChildByIndex(desiredIndex) {
    this.currenButtonIndex = desiredIndex;

    if (!this.isSmall) {
      const found = this.blockObjects.find(
        (block, index) => index === desiredIndex
      );

      const { title, eyebrow, description, link, linkText, image, ctaStyle } =
        found;
      this.currentTitle = title;
      this.currentEyebrow = eyebrow;
      this.currentImage = image;
      this.currentDescription = description;
      this.currentLink = link;
      this.currentCtaStyle = ctaStyle;

      const currentLinkText = linkText
        ? linkText.split(' ', 2)
        : 'learn more'.split(' ', 2);

      const shadowTitle = this.shadowRoot.querySelector('.title');
      const shadowEyebrow = this.shadowRoot.querySelector('.eyebrow');
      const shadowImage = this.shadowRoot.querySelector('.image');
      const shadowDescription = this.shadowRoot.querySelector('.description');
      const shadowLink = this.shadowRoot.querySelector('.link');
      const shadowCtaStyle = this.shadowRoot.querySelector('.ctaStyle');

      shadowTitle && (shadowTitle.textContent = title);
      shadowEyebrow && (shadowEyebrow.textContent = eyebrow);

      shadowImage?.style &&
        (shadowImage.style.backgroundImage = `url('${image}')`);

      shadowDescription && (shadowDescription.textContent = description);
      shadowLink && (shadowLink.href = link);
      shadowCtaStyle && (shadowCtaStyle.className = ctaStyle);
      shadowLink &&
        (shadowLink.innerHTML = `
                ${currentLinkText[0]}
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="2" viewBox="0 0 27 2" fill="none">
                    <path d="M0 1H27" stroke="black" stroke-width="0.75"/>
                </svg>
                ${currentLinkText[1]}
      `);

      //this.render();
    } else {
      this.blockElements.forEach((element, index) => {
        if (index === desiredIndex) {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      });
    }

    this.buttons &&
      this.buttons.forEach((button, index) => {
        if (index === desiredIndex) button.style.backgroundColor = '#D2EAE5';
        else button.style.backgroundColor = 'rgba(255, 0, 0, 0)';
      });
  }

  get backgroundColor() {
    return this.getAttribute('backgroundColor');
  }

  set backgroundColor(value) {
    this.setAttribute('backgroundColor', value);
  }
}
